import React from 'react';

interface SendIconProps {
  className?: string;
  color?: string;
  size?: number;
}

export const SendIcon: React.FC<SendIconProps> = (props) => {
  const { className, color = '#507FEE', size = 36 } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 13 13" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 1C12.1515 1.15151 12.2044 1.37562 12.1367 1.57889L8.53666 12.3789C8.46765 12.5859 8.28571 12.7348 8.06912 12.7615C7.85253 12.7881 7.63992 12.6878 7.52276 12.5037L4.79025 8.20976L0.496299 5.47725C0.312189 5.36009 0.21189 5.14748 0.238554 4.93089C0.265218 4.7143 0.414088 4.53236 0.621116 4.46335L11.4211 0.863348C11.6244 0.795591 11.8485 0.848496 12 1ZM5.92087 7.87914L7.83918 10.8936L10.3056 3.49443L5.92087 7.87914ZM9.50558 2.69443L2.10639 5.16083L5.12087 7.07914L9.50558 2.69443Z" fill={color} />
    </svg>

  );
};
